import compose from 'recompose/compose';
import PropTypes from 'prop-types';
import React from 'react';
import toJS from 'shared/components/toJS';
import { connect } from 'react-redux';
import { prefixResources } from 'shared/utils/htmlHelpers';
import BrandInfoDisplay from '../components/BrandInfoDisplay';

const BrandInfoContainer = ({ id, brandInfo }) => {
	const markup = brandInfo.topics[id].body;
	const prefixedMarkup = prefixResources(markup);

	return <BrandInfoDisplay markup={prefixedMarkup} />;
};

BrandInfoContainer.propTypes = {
	id: PropTypes.string.isRequired,
	brandInfo: PropTypes.shape({
		logo: PropTypes.string,
		topics: PropTypes.arrayOf(PropTypes.object),
	}),
};

BrandInfoContainer.defaultProps = {
	brandInfo: {
		logo: '',
		topics: [{}],
	},
};

const mapStateToProps = state => {
	const brandInfo = state.brandInfo.get('brandInfo');
	return {
		brandInfo,
	};
};

// connect returns a function that accepts a component
export default compose(connect(mapStateToProps))(toJS(BrandInfoContainer));
